import axios from "axios"

export const setLuxaforLight = async (user, color) => {
  if (!user?.luxafor_token) return

  await axios.post("/api/luxafor/color", { color: color })
}
